/* =============================================================
   Costume Brainrot — comportements du thème
   Chaque bloc est indépendant : si la section n'est pas sur la
   page, le code se met simplement en veille.
   ============================================================= */
(function () {
  'use strict';

  /* ---------------------------------------------- Galerie produit ---- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelector('[data-gallery-thumbs]');
    if (!main || !thumbs) return;

    thumbs.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-full]');
      if (!button) return;
      main.src = button.dataset.full;
      main.srcset = button.dataset.srcset || '';
      main.alt = button.dataset.alt || '';
      Array.prototype.forEach.call(thumbs.children, function (child) {
        child.setAttribute('aria-current', child === button ? 'true' : 'false');
      });
    });
  }

  /* --------------------------------------------- Sélecteur quantité --
     Sur la fiche produit : minimum 1. Dans le panier : minimum 0 (retrait)
     et mise à jour automatique du panier à chaque changement.          */
  function initQuantity(root) {
    root.querySelectorAll('[data-qty]').forEach(function (widget) {
      var input = widget.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min, 10);
      var max = parseInt(input.max, 10);
      if (isNaN(min)) min = 1;
      if (isNaN(max)) max = 99;

      widget.addEventListener('click', function (event) {
        var button = event.target.closest('button[data-step]');
        if (!button) return;
        var next = (parseInt(input.value, 10) || min) + parseInt(button.dataset.step, 10);
        input.value = Math.min(max, Math.max(min, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.querySelectorAll('[data-cart-form]').forEach(function (form) {
      var update = form.querySelector('[data-cart-update]');
      if (update) update.hidden = true;
      form.addEventListener('change', function (event) {
        if (!event.target.matches('input[name="updates[]"]')) return;
        if (form.requestSubmit && update) form.requestSubmit(update);
        else form.submit();
      });
    });
  }

  /* ------------------------------------------------ Barre collante ---- */
  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-buy]');
    var anchor = root.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    document.body.classList.add('has-sticky-buy');

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', passed);
    }, { threshold: 0 }).observe(anchor);

    bar.querySelectorAll('[data-sticky-submit]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = document.getElementById(button.dataset.stickySubmit);
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  /* ------------------------------------- Estimation de livraison ------
     Calcule, à l'heure de Paris, le jour de départ (avant/après l'heure
     limite, hors week-end) puis la fourchette de livraison en jours
     ouvrés. Les réglages viennent des data-attributes du bloc.        */
  function initDelivery(root) {
    root.querySelectorAll('[data-delivery]').forEach(function (el) {
      if (el.dataset.estimate === 'false') return;

      var cutoff = parseInt(el.dataset.cutoff, 10);
      var minDays = parseInt(el.dataset.min, 10) || 2;
      var maxDays = parseInt(el.dataset.max, 10) || 4;
      var saturday = el.dataset.saturday === 'true';
      var carrier = el.dataset.carrier || '';
      var free = el.dataset.free || '';
      var cutoffLine = el.querySelector('[data-delivery-cutoff]');
      var etaLine = el.querySelector('[data-delivery-eta]');
      var eventLine = el.querySelector('[data-delivery-event]');
      if (isNaN(cutoff)) cutoff = 14;

      function parisNow() {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Paris', hourCycle: 'h23',
            year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
          }).formatToParts(new Date());
          var o = {};
          parts.forEach(function (p) { o[p.type] = p.value; });
          return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute);
        } catch (e) {
          return new Date();
        }
      }
      function isShipDay(d) { var w = d.getDay(); return w !== 0 && (saturday || w !== 6); }
      function isBusinessDay(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
      function addDays(d, n, ok) {
        var r = new Date(d.getTime());
        while (n > 0) { r.setDate(r.getDate() + 1); if (ok(r)) n -= 1; }
        return r;
      }
      function fmt(d) {
        try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
        catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
      }
      function parseDate(s) {
        var p = (s || '').split('-');
        if (p.length !== 3) return null;
        return new Date(+p[0], +p[1] - 1, +p[2], 23, 59);
      }

      function render() {
        var now = parisNow();
        var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var today = isShipDay(ship) && now.getHours() < cutoff;
        if (!today) ship = addDays(ship, 1, isShipDay);
        var from = addDays(ship, minDays, isBusinessDay);
        var to = addDays(ship, maxDays, isBusinessDay);

        if (cutoffLine) {
          if (today) {
            var left = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
            var h = Math.floor(left / 60);
            var m = left % 60;
            var when = (h > 0 ? h + ' h ' : '') + (h > 0 && m < 10 ? '0' : '') + m + ' min';
            cutoffLine.innerHTML = 'Commandez dans les <b>' + when + '</b> pour un départ <b>aujourd’hui</b>.';
          } else {
            var shipDay = fmt(ship);
            cutoffLine.innerHTML = 'Commandez maintenant pour un départ <b>' + shipDay + '</b>' + (/\.$/.test(shipDay) ? '' : '.');
          }
        }
        if (etaLine) {
          etaLine.innerHTML = 'Livraison estimée du <b>' + fmt(from) + '</b> au <b>' + fmt(to) + '</b>'
            + (carrier ? ' · ' + carrier : '') + (free ? ' · ' + free : '');
        }
        if (eventLine) {
          var orderBy = parseDate(el.dataset.eventOrderBy);
          var eventDate = parseDate(el.dataset.eventDate);
          if (orderBy && eventDate && now <= orderBy) {
            var days = Math.ceil((eventDate - now) / 86400000);
            eventLine.innerHTML = 'Commandez avant le <b>' + fmt(orderBy) + '</b> pour le recevoir avant '
              + (el.dataset.eventName || 'l’événement') + (days > 0 ? ' (J-' + days + ')' : '') + '.';
            eventLine.hidden = false;
          } else {
            eventLine.hidden = true;
          }
        }
      }

      render();
      setInterval(render, 30000);
    });
  }

  /* --------------------------------------------- Pixel TikTok ---------
     Le code de base est chargé dans layout/theme.liquid (snippet
     tiktok-pixel). Ici : AddToCart à l'envoi du formulaire produit,
     InitiateCheckout au clic sur « Passer commande ».                 */
  function initTikTok(root) {
    if (!window.ttq || document.body.dataset.ttqEvents !== 'true') return;

    root.querySelectorAll('form.product-form[data-ttq-id]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var price = parseFloat(form.dataset.ttqPrice) || 0;
        try {
          window.ttq.track('AddToCart', {
            contents: [{ content_id: form.dataset.ttqId, content_type: 'product', content_name: form.dataset.ttqName, quantity: qty, price: price }],
            value: Math.round(price * qty * 100) / 100,
            currency: form.dataset.ttqCurrency
          });
        } catch (e) { /* le pixel ne doit jamais bloquer l'achat */ }
      });
    });

    root.querySelectorAll('[data-ttq-checkout]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = button.closest('form');
        if (!form) return;
        var contents = [];
        try { contents = JSON.parse(form.dataset.ttqContents || '[]'); } catch (e) { contents = []; }
        try {
          window.ttq.track('InitiateCheckout', {
            contents: contents,
            value: parseFloat(form.dataset.ttqValue) || 0,
            currency: form.dataset.ttqCurrency
          });
        } catch (e) { /* idem */ }
      });
    });
  }

  /* ------------------------------------------------------- Avis ------ */
  function initReviews(root) {
    var section = root.querySelector('[data-reviews]');
    if (!section) return;

    var list = section.querySelector('[data-review-list]');
    var moreButton = section.querySelector('[data-review-more]');
    var counter = section.querySelector('[data-review-count]');
    var sorter = section.querySelector('[data-review-sort]');
    if (!list) return;

    var items = Array.prototype.slice.call(list.children);
    var perPage = parseInt(section.dataset.reviews, 10) || 6;
    var shown = perPage;

    function render() {
      var sort = sorter ? sorter.value : 'recent';
      var sorted = items.slice().sort(function (a, b) {
        var da = a.dataset.date || '';
        var db = b.dataset.date || '';
        var ra = parseFloat(a.dataset.rating) || 0;
        var rb = parseFloat(b.dataset.rating) || 0;
        if (sort === 'old') return da.localeCompare(db);
        if (sort === 'best') return rb - ra || db.localeCompare(da);
        if (sort === 'worst') return ra - rb || db.localeCompare(da);
        return db.localeCompare(da);
      });

      sorted.forEach(function (item, index) {
        item.hidden = index >= shown;
        list.appendChild(item);
      });

      var visible = Math.min(shown, items.length);
      if (counter) {
        counter.textContent = counter.dataset.template
          .replace('[shown]', visible)
          .replace('[total]', items.length);
      }
      if (moreButton) {
        var remaining = items.length - visible;
        moreButton.hidden = remaining <= 0;
        moreButton.textContent = moreButton.dataset.template.replace('[count]', remaining);
      }
    }

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        shown = items.length;
        render();
      });
    }
    if (sorter) sorter.addEventListener('change', render);

    render();
  }

  /* ------------------------------------------------------ Bootstrap -- */
  function boot(root) {
    initGallery(root);
    initQuantity(root);
    initStickyBar(root);
    initDelivery(root);
    initTikTok(root);
    initReviews(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  // Rechargement d'une section dans l'éditeur de thème
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
